export enum ACUserTier {
  Base = 'BASE',
  P25K = 'P25K',
  E35K = 'E35K',
  E50K = 'E50K',
  LE50K = 'LE50K',
  E75K = 'E75K',
  LE75K = 'LE75K',
  S100K = 'S100K',
  LS100K = 'LS100K',
  VIP = 'VIP',
  Default = '',
}
